
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/cookie-policy",
      function () {
        return require("private-next-pages/policies/cookie-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/cookie-policy"])
      });
    }
  